import { useNavigate } from 'react-router';
import RegisterForm from '../../features/auth/components/RegisterForm';
import { useAuth } from '../../features/auth/contexts/AuthContext';
import { ROUTES } from '../../constants/routes';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register, error } = useAuth();

  const handleRegister = async (email: string, password: string) => {
    const { requiresConfirmation } = await register(email, password);
    if (requiresConfirmation) {
      navigate('/verify-email', { state: { email } });
      return;
    }
    navigate(ROUTES.STANDARDISIERUNG);
  };

  return <RegisterForm onRegister={handleRegister} error={error} />;
};

export default RegisterPage;
